import { Injectable } from '@angular/core';

import { DataService } from '../../shared/services/data.service';
import { TaskConstantsService } from './task-constants.service';
import { BaseService } from '../../shared/services/base.service';

@Injectable()
export class TaskService {
  currentTaskId: number;
  public updatedTaskData: any;
  public currentTaskPageIndex: number;

  constructor(private dataService: DataService, private baseService: BaseService) { }

  getAllTaskIds() {
    return JSON.parse(this.baseService.getItemFromSession('taskIds'));
  }
  setAllTaskIds(taskIds) {
    this.baseService.setItemInSession('taskIds', JSON.stringify(taskIds));
  }
  setcurrentTaskId(id) {
    this.currentTaskId = id;
  }
  getCurrentTaskId() {
    return this.currentTaskId;
  }
  /**
   * Function to get risk request by id
   * @param Model - Model to send data to api with RiskRequestId
   * @param callbackMethod - return the response
   */
  // service call to get action trend report data
  getTaskSection(model, callbackMethod) {
    this.dataService.post(TaskConstantsService.ApiConstants.getTask, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  /**
* Function to Get Company Details
* @param model - Model contain Status
* @param callbackMethod - return the response
*/
  getTask(model, callbackMethod) {
    this.dataService.post(TaskConstantsService.ApiConstants.getTask, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  /**
* Function to Get Company Details
* @param model - Model contain Status
* @param callbackMethod - return the response
*/
  saveTask(model, callbackMethod) {
    this.dataService.post(TaskConstantsService.ApiConstants.saveTask, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  updateTask(model, callbackMethod) {
    this.dataService.post(TaskConstantsService.ApiConstants.updateTask, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  public setUpdatedTaskData(data) {
    this.updatedTaskData = data;
  }
  public getUpdatedTaskData() {
    return this.updatedTaskData;
  }

  /**
* Function to Get Company Details
* @param model - Model contain Status
* @param callbackMethod - return the response
*/
  getTaskList(model, callbackMethod) {
    this.dataService.post(TaskConstantsService.ApiConstants.getTaskList, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  getCheckList(model, callbackMethod) {
    this.dataService.post(TaskConstantsService.ApiConstants.getCheckList, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  getMonitoringMatrix(model, callbackMethod) {
    this.dataService.post(TaskConstantsService.ApiConstants.getMonitoringMatrix, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  getTaskDataById(model, callbackMethod) {
    this.dataService.post(TaskConstantsService.ApiConstants.GetTaskById, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  ExportToExcelTaskList(model, callbackMethod) {
    this.dataService.post(TaskConstantsService.ApiConstants.ExportToExcelTaskList, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  downloadPDF(model, callbackMethod) {
    this.dataService.postHttpResponse(TaskConstantsService.ApiConstants.DownloadPDF, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  downloadZIP(model, callbackMethod) {
    this.dataService.postHttpResponse(TaskConstantsService.ApiConstants.DownloadZIP, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
}
